(function () {
    "use strict";

    angular
        .module('iMatApp')
        .directive('clippingAxis', clippingAxisDirective);

    function clippingAxisDirective() {
        var directive = {
            templateUrl: '/Scripts/iMatApp/upload3DModel/views/clippingAxisTemplate.html',
            restrict: 'A',
            scope: {
                axis: '=ngModel',
                clippingFlipDirection: '='
            },
            link: link
        };

        return directive;

        function link(scope, element, attrs) {
            scope.isClippingDirectionFlipped = scope.clippingFlipDirection();

            scope.toggleClippingDirection = function () {
                scope.isClippingDirectionFlipped = !scope.isClippingDirectionFlipped;
                scope.clippingFlipDirection(scope.isClippingDirectionFlipped);
            };
        }
        
    }
})();